import React, { FC } from "react";
import "./Modal.scss";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  closeModal?: () => void;
  width?: string;
  children?: React.ReactNode;
  title?: string;
  zIndex?: number;
}

const Modal: FC<ModalProps> = (props) => {
  const onClose = () => {
    props.closeModal && props.closeModal();
  };

  return (
    <div
      className="modal"
      onMouseDown={onClose}
      style={{ zIndex: props.zIndex ? props.zIndex : 50 }}
    >
      <div
        className="modal__content"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        style={{ width: `${props.width}` }}
      >
        <div className="modal__container">
          {props.title && (
            <div className="modal__header">
              <h3>{props.title}</h3>
              {props.closeModal && (
                <div onClick={props.closeModal} className="modal__close-icon">
                  <CloseIcon />
                </div>
              )}
            </div>
          )}
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
